import { defineMessages } from 'react-intl'

export default defineMessages({
  confirmDelete: {
    id: 'ConfirmDelete',
    defaultMessage: 'Really want to delete?'
  },
  confirmDeleteSubMessage: {
    id: 'SpaceMembersPage.ManageUserRole.ConfirmDeleteSubMessage',
    defaultMessage: 'This member will be removed from this role'
  },
  loadingMembers: {
    id: 'SpaceMembersPage.LoadingMembers',
    defaultMessage: 'Loading Members'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  noUsers: {
    id: 'SpaceMembersPage.ManageUserRole.NoUsers',
    defaultMessage:
      'There are no users in this role that match the search criteria. You may need to add the user to the space and role.'
  },
  members: {
    id: 'members',
    defaultMessage: 'members'
  }
})
